import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmModalData {
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

/**
 * Yes/no confirmation dialog. Closes with true on confirm, false on cancel and
 * undefined on backdrop dismiss (callers treat anything but true as cancel).
 */
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.sass']
})
export class ConfirmModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmModalData) { }

  get confirmLabel(): string { return this.data?.confirmLabel || 'OK'; }
  get cancelLabel(): string { return this.data?.cancelLabel || 'Cancel'; }
}
